import Affiliate from './Affiliate';
import PHPCookie from './PHPCookie';

export default class Awin extends Affiliate {
    constructor() {
        super();
        this.affiliateName = 'awin';
        this.cookieDomain = new PHPCookie();
        this.cookieNames = ['awc'];
        this.validStores = ['PBUK', 'PBUS', 'PBCA', 'PBAU'];
    }

    prepareCookie() {
        const { awc } = this.urlParams;
        this.cookieDomain.sendCookie({ name: 'awc', value: awc, httponly: 1 });
    }
}


// WEBPACK FOOTER //
// ./src/Common/Helpers/TrackingAffiliate/Awin.js